<template>
    <div class="filtersWrapper d-flex flex-column">
    <div class="filters d-block">
        <div class="titulo-pagina pa-6">Pedidos</div>
        <v-list class="pl-3" width="100%">
            <v-list-item-group v-model="selecaoFiltro" color="white" active-class="filtro-ativo" mandatory>
<!-- Solicitado -->
                <v-list-item class="btnFilters" @click="loadPedido(URLS.SOLICITADOS)">
                    <v-list-item-content class="fill-height align-content-start">
                        <v-list-item-title class="titulo-filter">
                                 <span class="dot" v-if="filtros.solicitados.exibe_marcador"
                                       :style="'background-color: ' + filtros.solicitados.st_cor +';'"/>
                            Solicitados
                        </v-list-item-title>
                        <v-list-item-subtitle class="subtitulo-filter"
                                              style="font: 460 40px/53px Roboto; color: #37565C; letter-spacing: 0">
                            <animated-number :numero="filtros.solicitados.nr_pedidos"/>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon class="fill-height align-self-center">
                        <v-icon color="#008EF0">
                            fas fa-chevron-right
                        </v-icon>
                    </v-list-item-icon>
                </v-list-item>
<!-- Confirmados -->
                <v-list-item class="btnFilters" @click="loadPedido(URLS.CONFIRMADOS)">
                    <v-list-item-content class="fill-height align-content-start">
                        <v-list-item-title class="titulo-filter">
                                 <span class="dot" v-if="filtros.confirmados.exibe_marcador"
                                       :style="'background-color: ' + filtros.confirmados.st_cor +';'"/>
                            Confirmados
                        </v-list-item-title>
                        <v-list-item-subtitle class="subtitulo-filter"
                                              style="font: 460 40px/53px Roboto; color: #37565C; letter-spacing: 0">
                            <animated-number :numero="filtros.confirmados.nr_pedidos" />
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon class="fill-height align-self-center">
                        <v-icon color="#008EF0">
                            fas fa-chevron-right
                        </v-icon>
                    </v-list-item-icon>
                </v-list-item>
<!-- Atrasados -->
                <v-list-item class="btnFilters" @click="loadPedido(URLS.ATRASADOS)">
                    <v-list-item-content class="fill-height align-content-start">
                        <v-list-item-title class="titulo-filter">
                                 <span class="dot" v-if="filtros.atrasados.exibe_marcador"
                                       :style="'background-color: ' + filtros.atrasados.st_cor +';'"/>
                            Atrasados
                        </v-list-item-title>
                        <v-list-item-subtitle class="subtitulo-filter"
                                              style="font: 460 40px/53px Roboto; color: #37565C; letter-spacing: 0">
                            <animated-number :numero="filtros.atrasados.nr_pedidos" />
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon class="fill-height align-self-center">
                        <v-icon color="#008EF0">
                            fas fa-chevron-right
                        </v-icon>
                    </v-list-item-icon>
                </v-list-item>
<!-- Cancelados -->
                <v-list-item class="btnFilters" @click="loadPedido(URLS.CANCELADOS)">
                    <v-list-item-content class="fill-height align-content-start">
                        <v-list-item-title class="titulo-filter">
                                 <span class="dot" v-if="filtros.cancelados.exibe_marcador"
                                       :style="'background-color: ' + filtros.cancelados.st_cor +';'"/>
                            Cancelados
                        </v-list-item-title>
                        <v-list-item-subtitle class="subtitulo-filter"
                                              style="font: 460 40px/53px Roboto; color: #37565C; letter-spacing: 0">
                            <animated-number :numero="filtros.cancelados.nr_pedidos" />
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon class="fill-height align-self-center">
                        <v-icon color="#008EF0">
                            fas fa-chevron-right
                        </v-icon>
                    </v-list-item-icon>
                </v-list-item>
<!-- Finalizados -->
                <v-list-item class="btnFilters" @click="loadPedido(URLS.FINALIZADOS)">
                    <v-list-item-content class="fill-height align-content-start">
                        <v-list-item-title class="titulo-filter">
                                 <span class="dot" v-if="filtros.finalizados.exibe_marcador"
                                       :style="'background-color: ' + filtros.finalizados.st_cor +';'"/>
                            Finalizados
                        </v-list-item-title>
                        <v-list-item-subtitle class="subtitulo-filter"
                                              style="font: 460 40px/53px Roboto; color: #37565C; letter-spacing: 0">
                            <animated-number :numero="filtros.finalizados.nr_pedidos" />
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon class="fill-height align-self-center">
                        <v-icon color="#008EF0">
                            fas fa-chevron-right
                        </v-icon>
                    </v-list-item-icon>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </div>


<!-- Btn Criar Pedido -->
        <div class="criar-pedido mt-auto mb-12 align-self-center" >
            <novo-pedido-dialog />
        </div>
    </div>
</template>
<script>
import NovoPedidoDialog from "@/modules/pedidosRacao/components/pedidosRacao/NovoPedidoDialog";
import AnimatedNumber from "@/modules/pedidosRacao/components/pedidosRacao/AnimatedNumber";
import {URLS} from "@/modules/pedidosRacao/resources";

export default {
    name: 'filtros-pedido',
    components: {AnimatedNumber, NovoPedidoDialog},
    data: () => ({
        URLS
    }),
    computed: {
        selecaoFiltro: {
            get() { return this.filtroSelecionado ? this.filtroSelecionado : 0 },
            set(value) {
                this.$emit('update:filtroSelecionado', value);
            }
        }
    },
    methods: {
        loadPedido(endpoint) {
            this.$emit('limparDtPrevista')
            this.$emit('loadPedido', {endpoint, blLimparFiltros: true});
        }
    },
    props: {
        filtroSelecionado: {
            type: Number,
            default: 0
        },
        filtros: {},
        dtPrevista: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="scss" scoped>
@import "src/modules/pedidosRacao/sass/variables";

.filters {
  background: $gray-500;
  position: sticky;
  top: 48px;
  width: 153px;
  overflow: hidden;
}

.filtersWrapper {
  background: $gray-500;
  width: 153px;
}

.criar-pedido {
  position: sticky;
  bottom: 48px;
  left: 0;
  right: 0;
  display: inline-table;
}

.dot {
  margin-bottom: 1px;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  display: inline-block;
}

.btnFilters {
  padding-left: 20px;
  padding-right: 0;
}

.btnFilters:hover {
  padding-left: 26px;
  background-color: rgba(242, 245, 243, 0.8);
}

.subtitulo-filter {
  overflow: visible;
  width: 100%;
  letter-spacing: 0;
  color: $gray-200;
  opacity: 1;
  margin-top: 0;
}

.titulo-filter {
  font: normal normal normal 10px/13px Roboto !important;
  letter-spacing: 0;
  color: $gray-300;
}

.titulo-pagina {
  font: normal normal bold 24px/32px Roboto;
  letter-spacing: 0;
  color: $gray-200;

  background: $gray-500;
}

.v-list-item-group .v-list-item:last-child .subtitulo-filter {
  font: 500 24px/32px Roboto !important;
  letter-spacing: 0;
}

.v-list-item__icon {
  margin-left: 0px !important;
}

.v-list {
  background: $gray-500;
}

.v-list-item {
  padding-left: 20px;
  height: 90px;
  overflow: hidden;
  border-radius: 6px 0 0 6px;
  transition: 0.3s;
}

.v-list-item:hover::before {
  background-color: rgba(242, 245, 243, 0.8);
}

.filtro-ativo {
  background-color: $gray-700;
}

.filtro-ativo .v-icon::before, .v-list-item:hover .v-icon::before {
  margin-left: 6px;
  opacity: 1 !important;
}

.v-list-item .v-icon::before {
  opacity: 0;
  transition: 0.3s;
}

.v-list-item-group .v-list-item:last-child {
  height: 69px;
}
</style>